const visualSignatureRepository = (fetch: CustomFetch) => ({
  getDefault(params: Record<Extract<'leg' | 'qual', VisualSignatureParam>, string>) {
    const query = new URLSearchParams(params)
    return fetch<Blob>(`/v1/direct/visual-signature?${query.toString()}`)
  },
})

export default visualSignatureRepository
